import React from 'react'
import { ITooltip, Tooltip } from './tooltip'
import { MdHelp } from 'react-icons/md'

export function HelpTooltip(props: {
  content?: ITooltip['content']
  title?: ITooltip['title']
  link?: ITooltip['link']
  delay?: ITooltip['delay']
  icon?: React.JSX.Element
}) {
  if (!props.content) return null

  const icon = props.icon || <MdHelp color={'rgba(209, 213, 219, 1)'} />

  return <Tooltip {...props}>{icon}</Tooltip>
}
